import React from 'react';
import Layout from '../components/Layout';

const BASE = "/images/";

export default function Home() {
  return (
    <Layout bannerTitle="Guide to Connecting HP Printers to Windows and Mac">
      <div className="main-content" id="setup-section">

        {/* Zig-zag Method 1 */}
        <div className="zigzag-section">
          <div className="zigzag-text">
            <h2>Method 1: Wired Connection (USB)</h2>
            <p>A wired connection is often the most reliable way to set up a printer for the first time.</p>
            <p><strong>For Windows Users:</strong></p>
            <ul>
              <li>Connect the USB cable to your printer and then to an available USB port on your PC.</li>
              <li>In most cases, Windows will automatically detect the hardware and install the necessary drivers.</li>
              <li>To verify, go to <strong>Start &gt; Settings &gt; Devices &gt; Printers &amp; Scanners</strong>.</li>
              <li>If your printer is not listed, click <em>Add a printer or scanner</em> and follow the Windows prompts.</li>
            </ul>
            <p style={{ marginTop: '1rem' }}><strong>For Mac Users:</strong></p>
            <ul>
              <li>Connect the USB cable. If your Mac uses USB-C ports, you may require a Multiport Adapter.</li>
              <li>Go to <strong>Apple Menu &gt; System Settings &gt; Printers &amp; Scanners</strong>.</li>
              <li>Click the <em>Add Printer, Scanner, or Fax…</em> button.</li>
              <li>Select your printer from the list and click Add.</li>
            </ul>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}wired-connection.png`} alt="Wired connection on Windows" />
          </div>
        </div>

        {/* Zig-zag Method 2 — reversed */}
        <div className="zigzag-section reverse">
          <div className="zigzag-text">
            <h2>Method 2: Wireless Connection (Wi-Fi &amp; Bluetooth)</h2>
            <p>Wireless setups allow you to print from anywhere within your network range.</p>
            <p><strong>On the Printer:</strong></p>
            <ul>
              <li><strong>Wi-Fi:</strong> Navigate to the "Network" or "Wireless" menu on your printer's control panel. Select your Wi-Fi network and enter the password.</li>
              <li><strong>Bluetooth:</strong> Enable pairing mode on your printer (refer to your specific model's manual for the button combination).</li>
            </ul>
            <p style={{ marginTop: '1rem' }}><strong>On Your Computer:</strong></p>
            <ul>
              <li><strong>Windows:</strong> Go to Settings &gt; Devices &gt; Printers &amp; Scanners. Click Add a printer or scanner. Ensure your PC is on the same Wi-Fi network as the printer.</li>
              <li><strong>Mac:</strong> Ensure both the Mac and printer are on the same network. Navigate to System Settings &gt; Printers &amp; Scanners, click (+), and select your printer from the detected list.</li>
            </ul>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}wireless-windows.png`} alt="Wireless connection setup" />
          </div>
        </div>

        {/* Zig-zag Method 3 */}
        <div className="zigzag-section">
          <div className="zigzag-text">
            <h2>Method 3: Sharing a Printer on a Home Network</h2>
            <p>You can share a printer connected to one Windows PC with other devices on your local network.</p>
            <ul>
              <li>Open <strong>Settings &gt; Network &amp; Internet &gt; Status</strong>.</li>
              <li>Select <strong>Sharing Options</strong>.</li>
              <li>Under the "Private" profile, select <strong>Turn on file and printer sharing</strong>.</li>
              <li>Other computers on the same network can now "Find" this printer through their own "Add a Printer" settings.</li>
            </ul>
          </div>
          <div className="zigzag-media">
            <img src={`${BASE}wired-mac.png`} alt="Printer sharing on home network" />
          </div>
        </div>

        {/* Disclaimer */}
        <div className="disclaimer-box">
          <h3>Important Transparency &amp; Disclaimer</h3>
          <p><strong>Smart Device Assistant</strong> is an independent website providing general informational guides and tutorials for consumer electronics.</p>
          <p><strong>Non-Affiliation:</strong> We are not affiliated with, authorized by, or endorsed by HP (Hewlett-Packard) or any other hardware manufacturer.</p>
          <p><strong>Brand Names:</strong> All product names, logos, and brands are property of their respective owners and are used here for identification purposes only.</p>
          <p><strong>No Support Services:</strong> This website is for educational purposes. We do not provide remote technical support, repair services, or software installations.</p>
        </div>

      </div>
    </Layout>
  );
}
